export interface IModelCheckQuotaResponse {
  quotaWarning: string;
  isLimit: boolean;
}

export class ModelCheckQuota {
  quotaWarning: string;
  isLimit: boolean;

  constructor(props = {} as IModelCheckQuotaResponse) {
    this.quotaWarning = props.quotaWarning;
    this.isLimit = props.isLimit;
  }
}